import React from 'react';
import { translate } from '../../common/translate/translations';
import { useModelInfo } from '../../common/ModelInfoContext';

const PriceSummaryExpandedDisclaimer = ({ symbol, message, include }) => {
  if (!include) {
    return null;
  }

  return (
    <div className="price-summary-expanded__disclaimer">
      <span>{symbol + ' '}</span>
      <span dangerouslySetInnerHTML={{ __html: message }} />
    </div>
  );
};

const PriceSummaryExpandedLineDisclaimers = ({ lines }) => {
  return lines.map((line, index) => (
    <PriceSummaryExpandedDisclaimer
      key={index}
      message={line.disclaimers.join(' ')}
      symbol={index + 1}
      include={true}
    />
  ));
};

const PriceSummaryExpandedDisclaimers = ({ pricing }) => {
  const { employeePrice, accessoriesTotal, incentives } = pricing;
  const { isCanada } = useModelInfo();
  const isCanadaEmployeePrice = isCanada && employeePrice;
  return (
    <div className="price-summary-expanded__disclaimers">
      <PriceSummaryExpandedDisclaimer
        symbol={'\u2020'}
        message={incentives.disclaimer}
        include={!isCanadaEmployeePrice}
      />
      <PriceSummaryExpandedLineDisclaimers lines={incentives.lines} />
      <PriceSummaryExpandedDisclaimer
        symbol={'\u2020'}
        message={translate('byo.disclaimer.total.price')}
        include={isCanadaEmployeePrice}
      />
      <PriceSummaryExpandedDisclaimer
        symbol={'\u2021'}
        message={translate('byo.page.general.disclaimer.msrp.2')}
        include={accessoriesTotal}
      />
      <PriceSummaryExpandedDisclaimer
        symbol={'*'}
        message={translate('byo.disclaimer.total.employee.price')}
        include={isCanadaEmployeePrice}
      />
      <PriceSummaryExpandedDisclaimer
        symbol={'^'}
        message={translate('byo.disclaimer.employee.net.price')}
        include={isCanadaEmployeePrice}
      />
    </div>
  );
};

export default PriceSummaryExpandedDisclaimers;
